import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { BaseApi } from 'src/backend/api/base-api';
import { Feature } from 'src/backend/models/features';

@Injectable({
    providedIn: 'root'
})
export class FeatureService {

    constructor(private http: HttpClient, private baseApi: BaseApi) { }


    getAllFeatures(): Observable<Feature[]> {
        return this.http.get<Feature[]>(this.baseApi.encodeURL(Constants.API_FEATURES));
    }
    getFeaturesByVarients(varients: string): Observable<Feature[]> {
        return this.http.get<Feature[]>(this.baseApi.encodeURL(Constants.API_FEATURES_BY_VARIENTS + '/' + varients));
    }

    getFeaturesByGroup(grpCode: string): Observable<Feature[]> {
        return this.http.get<Feature[]>(this.baseApi.encodeURL(Constants.API_FEATURES_BY_GRP) + '/' + grpCode);
    }
    getFeaturesByPlant(plantCode: string): Observable<Feature[]> {
        return this.http.get<Feature[]>(this.baseApi.encodeURL(Constants.API_FEATURES_BY_PLANT) + '/' + plantCode);
    }

}
